import * as React from "react"
import type { Account } from "@/types"
import type { CollectionTransaction, TransactionKind } from "../types"

export function useCarteraDialogs() {
  const [transactionType, setTransactionType] = React.useState<TransactionKind>("EXPENSE")
  const [isTransactionDialogOpen, setIsTransactionDialogOpen] = React.useState(false)
  const [editingTransaction, setEditingTransaction] = React.useState<CollectionTransaction | null>(null)
  const [deletingTransaction, setDeletingTransaction] = React.useState<CollectionTransaction | null>(null)
  
  const [isAccountDialogOpen, setIsAccountDialogOpen] = React.useState(false)
  const [editingAccount, setEditingAccount] = React.useState<Account | null>(null)
  const [deletingAccount, setDeletingAccount] = React.useState<Account | null>(null)

  const openTransactionDialog = React.useCallback((kind: TransactionKind = "EXPENSE") => {
    setTransactionType(kind)
    setEditingTransaction(null)
    setIsTransactionDialogOpen(true)
  }, [])

  const openEditTransactionDialog = React.useCallback((tx: CollectionTransaction) => {
    setEditingTransaction(tx)
    setTransactionType(tx._type)
    setIsTransactionDialogOpen(true)
  }, [])

  const closeTransactionDialog = React.useCallback(() => {
    setIsTransactionDialogOpen(false)
    setEditingTransaction(null)
  }, [])

  const openDeleteTransactionDialog = React.useCallback((tx: CollectionTransaction) => {
    setDeletingTransaction(tx)
  }, [])

  const closeDeleteTransactionDialog = React.useCallback(() => {
    setDeletingTransaction(null)
  }, [])

  const openAccountDialog = React.useCallback(() => {
    setEditingAccount(null)
    setIsAccountDialogOpen(true)
  }, [])

  const openEditAccountDialog = React.useCallback((acc: Account) => {
    setEditingAccount(acc)
    setIsAccountDialogOpen(true)
  }, [])

  const closeAccountDialog = React.useCallback(() => {
    setIsAccountDialogOpen(false)
    setEditingAccount(null)
  }, [])

  const openDeleteAccountDialog = React.useCallback((acc: Account) => {
    setDeletingAccount(acc)
  }, [])

  const closeDeleteAccountDialog = React.useCallback(() => {
    setDeletingAccount(null)
  }, [])

  return {
    transactionType,
    isTransactionDialogOpen,
    editingTransaction,
    deletingTransaction,
    isAccountDialogOpen,
    editingAccount,
    deletingAccount,
    setIsTransactionDialogOpen,
    setIsAccountDialogOpen,
    openTransactionDialog,
    openEditTransactionDialog,
    closeTransactionDialog,
    openDeleteTransactionDialog,
    closeDeleteTransactionDialog,
    openAccountDialog,
    openEditAccountDialog,
    closeAccountDialog,
    openDeleteAccountDialog,
    closeDeleteAccountDialog,
  }
}

